// Spreadsheet navigation: arrow keys never increment numeric inputs.
export function handleCalculationNavigation(event) {
 const field=event.target;
 if(!field?.matches?.('input,select')||event.isComposing||event.ctrlKey||event.metaKey)return;
 if(field.tagName==='SELECT'){
  if(event.key===' '||(event.altKey&&event.key==='ArrowDown')){field.dataset.keyboardEditing='true';return;}
  if(field.dataset.keyboardEditing==='true'){
   if(['Enter','Escape','Tab'].includes(event.key))delete field.dataset.keyboardEditing;
   return;
  }
 }
 if(event.altKey)return;
 const direction=event.key==='ArrowUp'||event.key==='ArrowLeft'||(event.key==='Enter'&&event.shiftKey)?-1:['ArrowDown','ArrowRight','Enter'].includes(event.key)?1:0;
 if(!direction)return;
 event.preventDefault();
 const fields=[...event.currentTarget.querySelectorAll('input:not([disabled]):not([readonly]),select:not([disabled])')];
 const next=fields[fields.indexOf(field)+direction];
 if(next){next.focus();if(next.tagName==='INPUT')next.select();}
}
export function leaveCalculationMenu(event){
 if(event.target?.tagName==='SELECT')delete event.target.dataset.keyboardEditing;
}
